import React from "react";
import { useLocation, useNavigate, useParams, Navigate } from "react-router-dom";
import RightDrawer, { RightDrawerBody } from "../ui/RightDrawer";
import EventPage from "../../pages/EventPage";
import ClassPage from "../../pages/ClassPage";
import { RESERVED_CITY_SLUGS } from "../../lib/eventLinks";
import { listingDrawerBackground } from "../../lib/listingDrawer";

function ListingDrawerShell({ ariaLabel, testId, children }) {
  const location = useLocation();
  const nav = useNavigate();
  const background = listingDrawerBackground(location);

  function onClose() {
    if (background?.pathname) {
      nav(-1);
      return;
    }
    nav("/");
  }

  return (
    <RightDrawer
      open
      onClose={onClose}
      tier="medium"
      trapFocus={false}
      showClose={false}
      ariaLabel={ariaLabel}
      testId={testId}
      closeTestId={`${testId}-close`}
      backdropTestId={`${testId}-backdrop`}
    >
      <RightDrawerBody>{children}</RightDrawerBody>
    </RightDrawer>
  );
}

/** Event detail in a Medium right drawer (opened from host/school listings). */
export function PublicEventListingDrawer() {
  const { citySlug } = useParams();
  if (!citySlug || RESERVED_CITY_SLUGS.has(citySlug.toLowerCase())) {
    return <Navigate to="/" replace />;
  }
  return (
    <ListingDrawerShell ariaLabel="Event details" testId="public-event-drawer">
      <EventPage />
    </ListingDrawerShell>
  );
}

/** Class detail in a Medium right drawer (opened from host/school listings). */
export function PublicClassListingDrawer() {
  return (
    <ListingDrawerShell ariaLabel="Class details" testId="public-class-drawer">
      <ClassPage />
    </ListingDrawerShell>
  );
}
